import { useLocalization } from '../../../../../context/Localization/localization';
import { GMButtonGroup } from '../../../../../controls/ButtonGroup';
import { CTAButton } from '../../../../../controls/ButtonBase';
import { GMSizedIcon } from '../../../../../controls/Icon';
import { ScrollableBody } from '../../../../Layout/ScrollableBody/ScrollableBody';
import { KeyManagementHeader } from '../../../../../controls/KeyManagementHeader/KeyManagementHeader';

export const StoreKeyComplete = (props: { onProceed: () => void; }) => {
    const Localization = useLocalization();

    return (
        <ScrollableBody
            heading={
                <KeyManagementHeader
                    error={Localization.ProcessComplete}
                    secondaryHeading={Localization.KeyConfirmed}
                    showMustache
                />
            }
            proceedButtons={
                <GMButtonGroup
                    buttons={[
                        <CTAButton
                            onClick={props.onProceed}
                            label={Localization.Finish}
                            styleType={'primary'}
                            kioskOptions={{ inlineOptions: { sizedIcon: <GMSizedIcon iconType={'Complete'} iconSize={'custom'} /> } }}
                            ariaLabel={Localization.Finish}
                            id={Localization.Finish}
                        />,
                    ]}
                />
            }
        />
    );
};
